import React from 'react'
import { Columns, Header } from 'components/elements'
import RatingStars from '../../../elements/ratingStars'
import './homeReview.sass'

export const ReviewList = () => {
  return (
    <>
      <Columns className="home-review-block is-mobile">
        <Columns.Column size={2}>
          <img
            src="https://res.cloudinary.com/twisted-road/image/upload/fl_progressive,c_fill,g_face,q_auto,h_100,w_100,f_auto/v1566592705/frontend_assets/marketing/danielev.jpg"
            className="home-review-avatar is-rounded"
            alt="Name Here."
            width="640px"
            height="360px"
          />
        </Columns.Column>
        <Columns.Column size={10}>
          <p
            className="mb-0 has-text-weight-bold review-header is-size-5"
          >
            “An outstanding service”{' '}
            <RatingStars rating={5} showInfo={false} size="large" />
          </p>
          <p className="mt-2 home-review-body">
            I've rented my motorcycle out on Twisted Road nearly a dozen times
            over the past year. It is an outstanding service that makes me extra
            cash each month. Every renter I've had treated my motorcycle like
            their own. The Twisted Road team checks in on each rental and I rest
            easy knowing I'm covered by their insurance.{' '}
          </p>
          <strong className="reviewer">- Danielle V.</strong>
        </Columns.Column>
      </Columns>
      <Columns className="home-review-block is-mobile">
        <Columns.Column size={2}>
          <img
            src="https://res.cloudinary.com/twisted-road/image/upload/fl_progressive,c_fill,g_face,q_auto,h_100,w_100,f_auto/v1568781351/frontend_assets/marketing/RFO17.jpg"
            className="home-review-avatar is-rounded"
            alt="Name"
            width="640px"
            height="360px"
          />
        </Columns.Column>
        <Columns.Column size={10}>
          <p
            className="mb-0 has-text-weight-bold review-header is-size-5"
          >
            “We couldn't be happier.”{' '}
            <RatingStars rating={5} showInfo={false} size="large" />
          </p>
          <p className="mt-2 home-review-body">
            The team behind TR is bar-none one of the best we’ve worked with not
            in just the the rental space, but business in general. We couldn’t
            be happier with the results and opportunities that have come from
            working with them!
          </p>
          <strong className="reviewer">- Jason Paul Michaels</strong>
        </Columns.Column>
      </Columns>
      <Columns className="home-review-block is-mobile">
        <Columns.Column size={2}>
          <img
            src="https://res.cloudinary.com/twisted-road/image/upload/fl_progressive,c_fill,g_face,q_auto,h_100,w_100,f_auto/v1566402188/frontend_assets/homepage-images/22454.jpg"
            className="home-review-avatar is-rounded"
            alt="Name Here."
            width="640px"
            height="360px"
          />
        </Columns.Column>
        <Columns.Column size={10}>
          <p
            className="mb-0 has-text-weight-bold review-header is-size-5"
          >
            "I'll be back."{' '}
            <RatingStars rating={5} showInfo={false} size="large" />
          </p>
          <p className="mt-2 home-review-body">
            Cool garage, the owner was easy to work with and to accommodate.
            I’ll be back next trip!
          </p>
          <strong className="reviewer">- Kelly C., Rochester, MI</strong>
        </Columns.Column>
      </Columns>
    </>
  )
}

const HomeReview = () => (
  <Columns className="is-vcentered">
    <Columns.Column size={6} className="hide-mobile">
      <img
        src="https://res.cloudinary.com/twisted-road/image/upload/s--h_S1JXRf--/fl_progressive,c_scale,q_auto,h_500,q_jpegmini:1,f_auto/v1565145350/frontend_assets/homepage-images/reviews-image-decoraation-callout.jpg"
        alt="Photo of a group of people posing with motorcycles"
        width="540px"
        height="260px"
      />
    </Columns.Column>
    <Columns.Column size={5} offset={1}>
      <h2 className="rider-review-header">
        Thousands of <span className="is-size-2 has-text-weight-bold">5.0</span>{' '}
        star reviews And counting.
      </h2>
      <ReviewList />
      <div className="has-text-centered mt-6">
        <a href="/reviews" className="button is-medium is-primary is-outlined">
          Read More Reviews
        </a>
      </div>
    </Columns.Column>
  </Columns>
)

export default HomeReview
